import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    padding: ${rem(30)} 0;

    @media (min-width: ${breakpoints.md}px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
`;

export const Areas = styled.div`
    padding: 0 ${rem(10)};
    margin-top: ${rem(20)};

    @media (min-width: ${breakpoints.xs}px) {
        display: flex;
        flex-direction: row;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.xs}px) {
        width: ${rem(300)};
    }
`;

export const Area = styled.span`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(25)};
    color: ${({ theme }) => theme.colors.grey};
    margin-bottom: ${rem(25)};
    padding-right: ${rem(15)};

    svg {
        width: ${rem(18)};
        height: ${rem(18)};
        margin-right: ${rem(10)};
        margin-bottom: ${rem(-2)};

        g line,
        polyline {
            stroke: ${({ theme }) => theme.colors.grey};
        }
    }
`;

export const Image = styled.img`
    display: block;
    width: 100%;
    margin-top: ${rem(40)};

    @media (min-width: ${breakpoints.md}px) {
        width: 40%;
    }
`;

export const ShowMoreButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    width: 100%;
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary};
    text-align: left;
    padding: 0 0 0 ${rem(20)};
    margin-top: ${rem(20)};

    @media (min-width: ${breakpoints.xs}px) {
        display: none;
    }
`;
